import locator from '@/service-locator'
import { ADS_TRACKING_EVENTS } from '@/plugins/tracking/event'

const SESSION_START_EVENTS = [
  ADS_TRACKING_EVENTS.ads_campaign_create_start,
  ADS_TRACKING_EVENTS.ads_campaign_edit_start,
  ADS_TRACKING_EVENTS.ads_topup_start,
]

const SESSION_ID_FIELD = {
  [ADS_TRACKING_EVENTS.ads_campaign_create_start]:
    'ads_campaign_create_session_id',
  [ADS_TRACKING_EVENTS.ads_campaign_create_progress]:
    'ads_campaign_create_session_id',
  [ADS_TRACKING_EVENTS.ads_campaign_create_complete]:
    'ads_campaign_create_session_id',
  [ADS_TRACKING_EVENTS.ads_campaign_edit_start]: 'ads_campaign_edit_session_id',
  [ADS_TRACKING_EVENTS.ads_campaign_edit_complete]:
    'ads_campaign_edit_session_id',
  [ADS_TRACKING_EVENTS.ads_topup_start]: 'ads_topup_session_id',
  [ADS_TRACKING_EVENTS.ads_topup_progress]: 'ads_topup_session_id',
  [ADS_TRACKING_EVENTS.ads_topup_complete]: 'ads_topup_session_id',
}

const emitAdsEvent = (event, parameters = {}) => {
  if (SESSION_START_EVENTS.includes(event)) {
    localStorage.setItem(SESSION_ID_FIELD[event], Date.now())
  }

  if (SESSION_ID_FIELD[event]) {
    parameters.form_session_id = JSON.parse(
      localStorage.getItem(SESSION_ID_FIELD[event])
    )
  }

  parameters.merchant_id = localStorage.getItem('selectedMerchant')

  locator.tracking.event(event, parameters)
}

export { emitAdsEvent }
